import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { truncateAddress } from 'utils/eth';
import { BodyText, View, Row, Divider } from 'modules/styled';
import { useWeb3React } from 'app/web3/hooks';
import { getNetworkName } from 'app/web3/utils';

CashoutFooter.propTypes = {
  customButton: PropTypes.node,
};

export function CashoutFooter({ customButton }) {
  const { chainId, account } = useWeb3React();
  const rightEl = customButton || (
    <BodyText>Connected to Ethereum {getNetworkName(chainId)}</BodyText>
  );

  const leftEl = account ? <BodyText>{truncateAddress(account)}</BodyText> : <BodyText />;
  return (
    <Fragment>
      <Divider sx={{ mt: 4, mb: 4 }} />
      <Row sx={{ justifyContent: 'space-between' }}>
        <View>{leftEl}</View>
        <View>{rightEl}</View>
      </Row>
    </Fragment>
  );
}
